(function ($) {

    $('.hero__scroll-to-circ, .bio-hero__scroll-to-circ').on('click', function (e) {
        e.preventDefault();
        let target = $(this).closest('section').next();
        if(target.length > 0) {
            $('html, body').stop().animate({
                'scrollTop': target.offset().top - 20
            });
        }
    });


})(jQuery);
